// letterExamples.js
//
// Auto-derives, from the existing word list, which words illustrate each letter
// in each positional shape. The lessons reuse these words (and their recordings)
// as real examples. Manual picks in letterExamplesOverrides.js win.

import { dariWords } from './dariWords';
import { letterExamplesOverrides } from './letterExamplesOverrides';
import { positionAt } from './letterForms';

// letter -> { isolated:[words], initial:[words], medial:[words], final:[words] }
function buildExamples(words) {
  const map = {};
  for (const { dari } of words) {
    const letters = Array.from(dari);
    letters.forEach((letter, i) => {
      const pos = positionAt(dari, i);
      if (!map[letter]) map[letter] = { isolated: [], initial: [], medial: [], final: [] };
      if (!map[letter][pos].includes(dari)) map[letter][pos].push(dari);
    });
  }
  return map;
}

let _cache = null;
export function getExamples() {
  if (!_cache) _cache = buildExamples(dariWords);
  return _cache;
}

// Best example word for a letter in a position. Prefers (1) a manual override,
// (2) a word that has a recording, then (3) the shortest word (clearest).
// Returns a word string, or null if the corpus has none for that position.
export function pickExample(letter, position, recordedSet) {
  const override = letterExamplesOverrides[letter] && letterExamplesOverrides[letter][position];
  if (override) return override;

  const candidates = (getExamples()[letter] && getExamples()[letter][position]) || [];
  if (candidates.length === 0) return null;

  const recorded = recordedSet
    ? candidates.filter((w) => recordedSet.has(w))
    : [];
  const pool = recorded.length ? recorded : candidates;
  return [...pool].sort((a, b) => Array.from(a).length - Array.from(b).length)[0];
}

// Any example word for a letter (used by cards when a specific position has none).
export function anyExample(letter, recordedSet) {
  for (const pos of ['initial', 'medial', 'final', 'isolated']) {
    const w = pickExample(letter, pos, recordedSet);
    if (w) return { word: w, position: pos };
  }
  return null;
}

// Dev helper: returns letters/positions with no example word, for curation.
// Call from a console: import('./letterExamples').then(m => console.table(m.coverageReport()))
export function coverageReport() {
  const ex = getExamples();
  const gaps = [];
  for (const { dari } of dariWordsLetters()) {
    const forms = ex[dari];
    if (!forms) { gaps.push({ letter: dari, missing: 'ALL' }); continue; }
  }
  return gaps;
}

function dariWordsLetters() {
  // unique letters present across the corpus
  const seen = new Set();
  const out = [];
  for (const { dari } of dariWords) {
    for (const ch of Array.from(dari)) {
      if (!seen.has(ch)) { seen.add(ch); out.push({ dari: ch }); }
    }
  }
  return out;
}
